import { Meter } from '@studio/design-system/audio/meter';
import type { ReactElement } from 'react';
import type { PlaceholderProps } from './types.js';

/** Meter `<Placeholder>` component. */
export const Placeholder = (props: PlaceholderProps): ReactElement => (
  <Meter className='opacity-50' value={0} {...props} />
);
